<template>
  <RichText :content="value" />
</template>

<script>
export default {
  name: "ControlApolloGridRichTextEditor",
  props: {
    value: {
      type: String,
      default: null,
    },
  },
};
</script>
